var map = {
	"./ico-monitor.png": 1202,
	"./ico-streaming.png": 1203,
	"./noimg.jpg": 1204
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2104;


//////////////////
// WEBPACK FOOTER
// ./src/app/website/pregao/assets/images ^\.\/.*$
// module id = 2104
// module chunks = 18